import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";
import { initializeCreatorData } from "@/data/data";


if (import.meta.env.DEV ) {
  // import("./utils/stats").then(({ initStats }) => initStats()).catch(() => {});
  import("./utils/eruda").then(({ initEruda }) => initEruda()).catch(() => {});
}

// Fetch creator artwork data before booting the UI/engine so ContentData,
// MicrositeData and INITIAL_CONTENT_ID are populated when they're read.
// `.finally` boots the UI even if the fetch fails (graceful degradation).
void initializeCreatorData().finally(() => {
  import("./main.app.ui").then(({ initUI }) => {
    initUI();
  });
});

emitter.on("ui-ready", () => {
  import("./main.app").then(({ initApp }) => {
    initApp();
  });
});

//----------------------------------------------------------------

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://abf83ced4f7d252752c1b82aad7a10c1@o1388406.ingest.us.sentry.io/4511567736209408",
    maxBreadcrumbs: 20,
    integrations: [
      Sentry.breadcrumbsIntegration({
        console: false,
        dom: false,
      }),
    ],
    beforeBreadcrumb(breadcrumb) {
      try {
        if (JSON.stringify(breadcrumb).length > 5000) return null;
      } catch {
        return null;
      }
      return breadcrumb;
    },
  });
}